import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { useSession } from '../auth/useSession'
import { AccountLayout } from './AccountLayout'
import { BookingsPage } from './BookingsPage'
import { BookingDetailPage } from './BookingDetailPage'
import { CancelBookingPage } from './CancelBookingPage'
import { ProfilePage } from './ProfilePage'
import { RescheduleBookingPage } from './RescheduleBookingPage'

/**
 * I6 — `/{slug}/account/*`.
 *
 * The guard runs above every screen so no child ever renders for a visitor without
 * a session, and it carries the path the visitor wanted in `?next=` so signing in
 * lands them where they were going.
 */
export function AccountRoutes() {
  const { slug, isAuthenticated, loading } = useSession()
  const location = useLocation()

  if (loading) {
    return (
      <div className="container-page flex justify-center py-section-gap-md">
        <div
          className="h-8 w-8 animate-spin rounded-full border-2 border-outline-variant border-t-primary"
          role="status"
          aria-label="Loading"
        />
      </div>
    )
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/${slug}/signin?next=${next}`} replace />
  }

  return (
    <Routes>
      <Route element={<AccountLayout />}>
        <Route index element={<BookingsPage />} />
        <Route path="bookings" element={<BookingsPage />} />
        <Route path="profile" element={<ProfilePage />} />
      </Route>
      {/* Detail, cancel and reschedule run without the tab strip: they are one task, not a tab. */}
      <Route path="bookings/:id" element={<BookingDetailPage />} />
      <Route path="bookings/:id/cancel" element={<CancelBookingPage />} />
      <Route path="bookings/:id/reschedule" element={<RescheduleBookingPage />} />
      <Route path="*" element={<Navigate to={`/${slug}/account`} replace />} />
    </Routes>
  )
}
